import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #fff;
  padding: ${(props) =>
    props.noPadding || props.showNewBannerWidgetView ? '0' : '12px 16px'};
  border-bottom: ${(props) =>
    props.showNewBannerWidgetView
      ? 'none'
      : '1px solid hsl(0deg, 0%, 0%, 10%)'};
  border-top: ${(props) =>
    props.moreProduct ? '1px solid hsl(0deg, 0%, 0%, 10%)' : 'none'};
  border-left: ${(props) =>
    props.productcategory == 'MyloCare' &&
    !props.showNewLandingPageUI &&
    !props.showNewBannerWidgetView
      ? '5px solid rgb(239, 78, 94)'
      : ''};

  & .anchor {
    display: block;
    position: relative;
    visibility: hidden;
    top: -98px;
  }

  & .lowOpacity {
    opacity: 0.4;
  }

  .videoOuter {
    video {
      width: 100%;
    }
  }
`;

export const ResponsiveImage = styled.img`
  display: block;
  max-width: 100%;
  width: 100%;
  height: auto;
`;

export const GridImage = styled.img`
  width: 16px;
  height: auto;
  position: relative;
  top: 2px;
`;

export const SectionTitle = styled.h2`
  font-size: 15px;
  font-weight: 500;
  color: hsl(0deg 0% 0% / 87%);
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;

  @media (max-width: 720px) {
    cursor: default;
  }

  &.plusImage {
    width: 14px;
    height: 14px;
    opacity: 0.87;
  }
`;

export const HeadingTitle = styled.h2`
  padding: 12px 0;
  font-size: 15px;

  color: rgb(0 0 0 / 80%);
  letter-spacing: 2px;
  font-weight: 600;
`;

export const SectionBody = styled.div`
  font-size: 14px;
  line-height: 1.36;
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const Description = styled.div`
  background-color: #fff;
  padding: 16px;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 2px 0px;
  @media (max-width: 720px) {
    padding: ${(props) => (props.heading ? '16px' : ' 0px')};
  }
  border-left: ${(props) =>
    props.productcategory == 'MyloCare' ? '5px solid rgb(239, 78, 94)' : ''};

  & .anchor {
    display: block;
    position: relative;
    visibility: hidden;
    top: -98px;
  }
`;

export const Detail = styled.div`
  font-size: 14px;
  color: hsl(0deg 0% 0% / 70%);
  padding: ${(props) =>
    props.contentalign == 'top' ? '12px 0 16px' : '12px 8px 16px 14px'};
  order: ${(props) => (props.contentalign == 'top' ? '-1' : '0')};
`;
export const Heading = styled.div`
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  color: hsl(0deg, 0%, 0%, 87%);
  padding-bottom: 6px;
`;
export const ListHeading = styled.li`
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  color: #6e6e6e;
  padding-bottom: 0px;
  list-style: disc;
  margin-left: 16px;
`;

export const TypeGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.contentalign == 'top'
      ? '1fr'
      : props.contentalign == 'bottom'
        ? `repeat(${props.gridcoloumn || 1}, 1fr)`
        : '94px 1fr'};
  align-items: ${(props) => (props.coloumngap ? 'start' : 'center')};
  column-gap: ${(props) => (props.coloumngap ? '20px' : 'initial')};
  text-align: ${(props) => (props.coloumngap ? 'center' : 'initial')};
  margin: 10px 0;
`;

export const GridList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-start;
  padding: 10px 0 8px;

  & li {
    font-size: 14px;
    color: hsl(0deg 0% 0% / 87%);
    padding-bottom: 4px;
    list-style: disc;
    margin-left: 16px;
  }
`;
export const BodyStyle = styled.div`
  font-size: 13px;
  line-height: 1.24;
  color: hsl(0deg 0% 0% / 87%);
  padding-left: 22px;
  padding-bottom: 16px;
`;

export const ExpertWidget = styled.div`
  border-radius: 10px;
  background: #f1f9f8;
  padding: 16px;
`;

export const ExpertBody = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.9);
  font-weight: 500;
  text-align: justify;
  padding: 6px 0;
  line-height: 21px;
`;
export const ExpertAvatar = styled.div`
  position: relative;

  & .coverimage {
    width: 50px;
    height: 50px;
  }

  & .expertAvatar {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 50%;
  }
`;

export const ExpertSubheading = styled.div`
  display: flex;

  & .title {
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    color: rgb(99, 176, 168);
    padding: 9px 14px;
  }

  & .specialization {
    color: hsl(0deg 0% 0% / 58%);
    padding-top: 6px;
    font-size: 11px;
  }
`;

export const ScrollAnchorAge = styled.a`
  display: block;
  position: relative;
  visibility: hidden;
  top: -75px;
`;
